import { render, staticRenderFns } from "./TablaCatecumenos.vue?vue&type=template&id=bb66aa72&scoped=true&"
import script from "./TablaCatecumenos.vue?vue&type=script&lang=js&"
export * from "./TablaCatecumenos.vue?vue&type=script&lang=js&"
import style0 from "./TablaCatecumenos.vue?vue&type=style&index=0&id=bb66aa72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb66aa72",
  null
  
)

export default component.exports